export const candidateSaveMessage = (failure, fallback = 'Changes could not be saved. Your edits are still available.') => {
  // Older PR 2830 responses can be HTTP 200 while dropping unknown fields.
  // Do not echo arbitrary request keys from ignoredFields.
  if (failure && Array.isArray(failure.ignoredFields) && failure.ignoredFields.length > 0) {
    return 'Some fields were not saved. Other changes may already be saved. Check the candidate and refresh field settings before retrying.';
  }
  const fieldErrors = failure && Array.isArray(failure.fieldErrors) ? failure.fieldErrors : [];
  const messages = fieldErrors.filter((fieldError) => {
    return typeof fieldError.label === 'string' && Number.isSafeInteger(fieldError.maxLength);
  }).map((fieldError) => {
    return `${fieldError.label}: maximum ${fieldError.maxLength.toLocaleString()} ${fieldError.unit === 'bytes' ? 'bytes' : 'characters'}. Shorten this field and save again.`;
  });
  if (messages.length > 0) {
    return messages.join(' ');
  }
  return failure && typeof failure.message === 'string' ? failure.message : fallback;
};

// Keep failure handling out of the success path: a rejected save must never
// reload candidate details or clear the caller's draft/dirty state.
export const runCandidateSave = async ({ request, onFailure, onSuccess, onOverbook }) => {
  let response;
  try {
    response = await request();
  } catch (error) {
    onFailure(error && error.response ? error.response.data : null);
    return;
  }
  const result = response && response.data;
  if (result && result.requiresOverbookPermissions) {
    onOverbook(result);
  } else if (result && Array.isArray(result.ignoredFields) && result.ignoredFields.length > 0) {
    // Older APIs may already have persisted the recognized subset.
    onFailure({ ...result, error: true, saved: false, partialSave: true });
  } else if (!result || result.error !== false) {
    onFailure(result);
  } else {
    onSuccess(result);
  }
};

export const candidateFieldChanges = (candidate, reference, fieldNames, normalizeText) => {
  const fields = {};
  Object.keys(candidate).forEach((field) => {
    // Keep the form's existing scalar comparison: number controls emit strings.
    // eslint-disable-next-line eqeqeq
    if (fieldNames.includes(field) && candidate[field] != reference[field]) {
      const value = candidate[field];
      fields[field] = typeof value === 'string' ? normalizeText(value.replace(/\n{3,}/g, '\n\n')) : value;
    }
  });
  return fields;
};

// A confirmed date change must not be sent again when retrying failed details.
// This is transient UI recovery state, not a persisted ledger or request ID.
export const candidateSaveRetryFields = (fields, candidateIds, confirmedDateChange) => {
  if (!confirmedDateChange || fields.pk_InterviewDate !== confirmedDateChange.interviewDate) {
    return fields;
  }
  const key = [...new Set(candidateIds.map(String))].sort().join(',');
  if (key !== confirmedDateChange.candidateKey) {
    return fields;
  }
  const retryFields = { ...fields };
  delete retryFields.pk_InterviewDate;
  return retryFields;
};
